import React, { createContext, useContext, useState, useCallback } from "react";
import NoCreditsPopup from "@/components/NoCreditsPopup";

const CreditGateContext = createContext();

export function useCreditGate() {
  return useContext(CreditGateContext);
}

export function CreditGateProvider({ children }) {
  const [popup, setPopup] = useState({ open: false, actionName: "", actionCost: 0 });

  const requireCredits = useCallback((actionName, actionCost) => {
    setPopup({ open: true, actionName, actionCost });
    return false;
  }, []);

  const closePopup = useCallback(() => {
    setPopup(p => ({ ...p, open: false }));
  }, []);

  return (
    <CreditGateContext.Provider value={{ requireCredits }}>
      {children}
      <NoCreditsPopup open={popup.open} onClose={closePopup} actionName={popup.actionName} actionCost={popup.actionCost} />
    </CreditGateContext.Provider>
  );
}
